<template>
    <ExpandingCreateButton
        :modelClass="modelClass"
        :text="
            $lang.get('Add :model', {
                model: $getBaseModelTranslation({
                    modelName: 'resource',
                }),
            })
        "
        :url="$localizedRoute('resource.create')"
        :data="{
            resourceable_id: modelId,
            resourceable_type: modelClass,
            display_id: 'secondarydisplay',
        }"
        :useTopMargin="useTopMargin"
        class="-mb-3 -mr-2 md:-mr-5"
    />
</template>

<script>
import ExpandingCreateButton from '@/Components/ModelComponents/ExpandingCreateButton.vue'

export default {
    components: {
        ExpandingCreateButton,
    },

    props: {
        modelId: {
            type: Number,
            required: true,
        },
        modelClass: {
            type: String,
            required: true,
        },
        useTopMargin: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
